<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    width="650px"
    :before-close="handleCancel"
    v-loading="loading">
    <el-form>
      <!-- 支付金额 -->
      <el-form-item label="支付金额">
        {{ paymentInfo.amount }}
      </el-form-item>

      <!-- 缴费时间 -->
      <el-form-item label="缴费时间">
        <span style="color:red">{{ paymentInfo.date }}</span>
      </el-form-item>

      <!-- 结算方式 -->
      <el-form-item label="结算方式" v-if="paymentInfo.payName">
        <span>{{ paymentInfo.payName }}</span>
      </el-form-item>

      <!-- CBS流水关联按钮 -->
      <el-form-item v-if="needAssociateFlow">
        <el-button type="warning" size="small" @click="openCbsFlowSelector">
          关联CBS流水 ({{ selectedFlowId ? '已选' : '未选' }})
        </el-button>
        <span v-if="selectedFlowId" style="margin-left: 10px; color: #67c23a;">
          已选流水可用金额: {{ selectedFlowAvailableAmount }}
        </span>
        <a href="https://crm.gdzawy.com:9000/#/new/detail?news_id=174" target="_blank">教程说明</a>
      </el-form-item>

      <!-- 操作按钮 -->
      <el-form-item>
        <el-button type="primary" @click="handleConfirm" :disabled="isSubmitDisabled">
          确认提交
        </el-button>
        <el-button @click="handleCancel">取消</el-button>
      </el-form-item>
    </el-form>

    <!-- CBS流水选择器 -->
    <cbs-flow-selector
      :visible.sync="cbsSelectorVisible"
      :pindex-id="paymentInfo.pindexId"
      :pay-amount="parseFloat(paymentInfo.amount || 0)"
      @confirm="handleFlowSelected"
      @close="cbsSelectorVisible = false"
    />
  </el-dialog>
</template>

<script>
import CbsFlowSelector from './CbsFlowSelector.vue';

export default {
  name: 'CbsPaymentConfirm',
  props: {
    visible: { type: Boolean, default: false },
    dialogTitle: { type: String, default: '确认支付?' },
    billType: { type: String, required: true }, // 账单类型：deposit/temporary/advance
    paymentInfo: {
      type: Object,
      default: () => ({
        amount: 0,
        date: '',
        payName: '',
        pindexId: 0,
        isTransfer: false // 是否为转账方式
      })
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      cbsSelectorVisible: false,
      selectedFlowId: null,
      selectedFlowData: null,
      hasCbsConfig: false,
      isSubmitDisabled: false
    };
  },
  computed: {
    needAssociateFlow() {
      return this.paymentInfo.isTransfer && this.hasCbsConfig;
    },
    selectedFlowAvailableAmount() {
      if (!this.selectedFlowData) return 0;
      return (
        parseFloat(this.selectedFlowData.incurred_amount) -
        parseFloat(this.selectedFlowData.reconciled_amount)
      ).toFixed(2);
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
      if (val) {
        if (this.paymentInfo.isTransfer) {
          this.checkCbsConfig();
          this.isSubmitDisabled = true;
        } else {
          this.isSubmitDisabled = false;
        }
      } else {
        this.resetData();
      }
    }
  },
  methods: {
    checkCbsConfig() {
      if (!this.paymentInfo.pindexId) {
        this.isSubmitDisabled = false;
        return;
      }
      this.$myhttp.post('admin/cbs/checkProjectCbsConfig', {
        pindex_id: this.paymentInfo.pindexId
      }, {
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(res => {
        if (res.data.code === 200) {
          this.hasCbsConfig = res.data.data.has_config;
          if (this.hasCbsConfig) {
            this.isSubmitDisabled = true;
          } else {
            this.isSubmitDisabled = false;
          }
        }
      }).catch(() => {
        this.isSubmitDisabled = false;
      });
    },
    openCbsFlowSelector() {
      this.cbsSelectorVisible = true;
    },
    handleFlowSelected(flowId, flowData) {
      this.selectedFlowId = flowId;
      this.selectedFlowData = flowData;
      this.isSubmitDisabled = false;
      this.cbsSelectorVisible = false;
      this.$message.success('已选择流水');
    },
    handleConfirm() {
      if (this.needAssociateFlow && !this.selectedFlowId) {
        this.$message.warning('请选择CBS银行流水');
        return;
      }
      this.loading = true;
      this.$emit('confirm', {
        flowId: this.selectedFlowId,
        billType: this.billType,
        paymentInfo: this.paymentInfo
      });
    },
    handleCancel() {
      this.dialogVisible = false;
      this.$emit('close');
    },
    resetData() {
      this.selectedFlowId = null;
      this.selectedFlowData = null;
      this.hasCbsConfig = false;
      this.isSubmitDisabled = false;
      this.loading = false;
    }
  },
  components: {
    CbsFlowSelector
  }
};
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/component/CbsPaymentConfirm.vue